import { render, staticRenderFns } from "./pos-contact-form.vue?vue&type=template&id=02be79d8&scoped=true&"
import script from "./pos-contact-form.vue?vue&type=script&lang=ts&"
export * from "./pos-contact-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be79d8",
  null
  
)

export default component.exports